/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { governanceMetricsGetApiV3GovernanceMetrics } from "../../funcs/governanceMetricsGetApiV3GovernanceMetrics.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$governanceMetricsGetApiV3GovernanceMetrics: ToolDefinition = {
  name: "governance-metrics-get-api-v3-governance-metrics",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await governanceMetricsGetApiV3GovernanceMetrics(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
